(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[858],{

/***/ 99392:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bang-gia/kim-cuong/[slug]",
      function () {
        return __webpack_require__(78562);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ui/MetaTag/index.tsx
var MetaTag = __webpack_require__(42031);
// EXTERNAL MODULE: ./components/ui/JsonLd/index.tsx
var JsonLd = __webpack_require__(59904);
// EXTERNAL MODULE: ./constants/business.ts
var business = __webpack_require__(56154);
// EXTERNAL MODULE: ./features/journal/components.tsx + 3 modules
var components = __webpack_require__(41046);
// EXTERNAL MODULE: ./features/journal/diamond-config.ts
var diamond_config = __webpack_require__(55187);
// EXTERNAL MODULE: ./features/journal/diamond-catalogue.ts
var diamond_catalogue = __webpack_require__(29233);
// EXTERNAL MODULE: ./features/journal/diamond-catalogue-view.tsx
var diamond_catalogue_view = __webpack_require__(9354);
// EXTERNAL MODULE: ./features/journal/price-tabs.tsx
var price_tabs = __webpack_require__(16609);
;// CONCATENATED MODULE: ./features/journal/diamond-detail.tsx












var DiamondDetailLayout = function(param) {
    var profile = param.profile, estimate = param.estimate, usd = param.usd;
    var ref;
    var input = profile.input;
    var shape = diamond_config/* SHAPES.find */.HS.find(function(param) {
        var value = param.value;
        return value === input.shape;
    });
    var path = (0,diamond_catalogue/* diamondProfilePath */.qZ)(profile.slug);
    var title = "Gi\xe1 tham khảo kim cương tự nhi\xean ".concat(shape.name, " ").concat((0,diamond_catalogue_view/* diamondCarat */.w1)(input.carat), " carat ").concat(input.color, "/").concat(input.clarity);
    var description = "Gi\xe1 tham khảo kim cương tự nhi\xean ".concat(shape.name, " ").concat((0,diamond_catalogue_view/* diamondCarat */.w1)(input.carat), " carat, m\xe0u ").concat(input.color, ", độ sạch ").concat(input.clarity, ". Xem th\xf4ng số, nguồn StoneAlgo v\xe0 quy đổi VND tại An Thư.");
    var cataloguePage = Math.floor(diamond_catalogue/* DIAMOND_PROFILES.findIndex */.oO.findIndex(function(param) {
        var slug = param.slug;
        return slug === profile.slug;
    }) / diamond_catalogue/* DIAMOND_PAGE_SIZE */.jJ) + 1;
    var catalogueHref = "".concat((0,diamond_catalogue/* diamondCataloguePath */.pq)(cataloguePage), "#danh-sach-gia");
    var sourceUrl = (estimate === null || estimate === void 0 ? void 0 : estimate.sourceUrl) || (0,diamond_config/* buildDiamondSourceUrl */.WB)(input);
    var related = diamond_catalogue/* DIAMOND_PROFILES.filter */.oO.filter(function(item) {
        return item.slug !== profile.slug && item.input.carat === input.carat;
    }).slice(0, 3);
    var gradeName = function(grade) {
        var ref;
        return ((ref = diamond_config/* GRADES.find */.Tw.find(function(param) {
            var value = param.value;
            return value === grade;
        })) === null || ref === void 0 ? void 0 : ref.label) || grade;
    };
    var specs = [
        [
            "H\xecnh dạng",
            "".concat(shape.name, " (").concat(shape.label, ")")
        ],
        [
            "Trọng lượng",
            "".concat((0,diamond_catalogue_view/* diamondCarat */.w1)(input.carat), " carat")
        ],
        [
            "M\xe0u sắc",
            input.color
        ],
        [
            "Độ sạch",
            input.clarity
        ],
        [
            "Thiết lập Cut",
            gradeName(input.cut)
        ],
        [
            "Độ đối xứng",
            gradeName(input.symmetry)
        ],
        [
            "Độ đ\xe1nh b\xf3ng",
            gradeName(input.polish)
        ],
        [
            "Huỳnh quang",
            ((ref = diamond_config/* FLUORESCENCE.find */.NY.find(function(param) {
                var value = param.value;
                return value === input.fluorescence;
            })) === null || ref === void 0 ? void 0 : ref.label) || input.fluorescence
        ], 
    ];
    var crumbs = [
        {
            label: "Trang chủ",
            href: "/"
        },
        {
            label: "Bảng gi\xe1",
            href: "/bang-gia/"
        },
        {
            label: "Kim cương",
            href: "/bang-gia/kim-cuong/"
        },
        {
            label: "".concat(shape.name, " ").concat((0,diamond_catalogue_view/* diamondCarat */.w1)(input.carat), " ct ").concat(input.color, "/").concat(input.clarity)
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* JournalShell */.C2, {
        activeKey: "bang-gia",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(diamond_catalogue_view/* DiamondNavigationStatus */.ap, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: title,
                titleBrand: "An Thư",
                description: description,
                handle: path,
                image: "".concat(business/* BUSINESS.appUrl */.aL.appUrl, "/logo-bg.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JsonLd/* default */.Z, {
                schema: [
                    (0,_object_spread/* default */.Z)({
                        "@context": "https://schema.org",
                        "@type": "WebPage",
                        "@id": "".concat(business/* BUSINESS.appUrl */.aL.appUrl).concat(path, "#page"),
                        url: "".concat(business/* BUSINESS.appUrl */.aL.appUrl).concat(path),
                        name: title,
                        description: description,
                        inLanguage: "vi",
                        publisher: {
                            "@id": business/* BUSINESS.id */.aL.id
                        }
                    }, estimate ? {
                        dateModified: estimate.updatedAt
                    } : {}),
                    {
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        itemListElement: crumbs.map(function(crumb, index) {
                            return {
                                "@type": "ListItem",
                                position: index + 1,
                                name: crumb.label,
                                item: "".concat(business/* BUSINESS.appUrl */.aL.appUrl).concat("href" in crumb ? crumb.href : path)
                            };
                        })
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Breadcrumb */.aG, {
                items: crumbs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
                className: "!tw-pt-6 !tw-pb-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Eyebrow */.j4, {
                        children: "AN THƯ \xb7 CẤU H\xccNH THAM KHẢO"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "tw-mt-3 tw-mb-0 tw-max-w-[960px] tw-font-jr tw-text-[28px] md:tw-text-[42px] tw-font-normal tw-leading-tight",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "tw-mt-3 tw-mb-0 tw-text-[14px] md:tw-text-[16px] tw-leading-relaxed tw-text-jr-mute",
                        children: [
                            "Kim cương tự nhi\xean \xb7 ",
                            shape.name,
                            " \xb7 ",
                            (0,diamond_catalogue_view/* diamondCarat */.w1)(input.carat),
                            " carat \xb7 M\xe0u ",
                            input.color,
                            " \xb7 Độ sạch ",
                            input.clarity
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(price_tabs/* PriceTabs */.A, {
                active: "diamond"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
                className: "!tw-pt-0 !tw-pb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-grid tw-gap-6 md:tw-grid-cols-[0.8fr_1.2fr]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-min-h-[250px] tw-flex-col tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-jr-line tw-bg-[#F0F5F0] tw-p-6 tw-text-jr-green",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(diamond_catalogue_view/* DiamondIllustration */._g, {
                                        shape: input.shape,
                                        large: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "tw-mt-6 tw-mb-0 tw-text-[13px]",
                                        children: [
                                            "Minh họa d\xe1ng cắt ",
                                            shape.name
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-min-w-0 tw-rounded-xl tw-border tw-border-jr-line tw-bg-white tw-p-6 md:tw-p-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "tw-m-0 tw-text-[15px] tw-font-medium tw-text-jr-mute",
                                        children: "Gi\xe1 ước t\xednh quốc tế"
                                    }),
                                    estimate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "tw-mt-3 tw-mb-0 tw-text-[36px] md:tw-text-[44px] tw-font-medium tw-leading-tight tw-tabular-nums tw-text-jr-green",
                                                children: [
                                                    (0,diamond_catalogue_view/* diamondUsd */.iO)(estimate.priceUsd),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-text-[14px] tw-font-normal",
                                                        children: "USD"
                                                    })
                                                ]
                                            }),
                                            (usd === null || usd === void 0 ? void 0 : usd.sell) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "tw-mt-2 tw-mb-0 tw-text-[20px] tw-tabular-nums",
                                                children: [
                                                    "≈ ",
                                                    (0,diamond_catalogue_view/* diamondVnd */.Aq)(estimate.priceUsd * usd.sell),
                                                    " ₫"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "tw-mt-4 tw-mb-0 tw-text-[13px] tw-text-jr-mute",
                                                children: [
                                                    "Dữ liệu StoneAlgo ng\xe0y ",
                                                    (0,diamond_catalogue_view/* diamondDate */.OR)(estimate.updatedAt)
                                                ]
                                            }),
                                            estimate.stale && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "tw-mt-3 tw-mb-0 tw-text-[13px] tw-leading-relaxed tw-text-jr-mute",
                                                children: "Đang kiểm tra lại nguồn. Gi\xe1 gần nhất được giữ k\xe8m ng\xe0y dữ liệu ở tr\xean."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                className: "tw-mt-6 tw-mb-0 tw-space-y-3 tw-border-0 tw-border-t tw-border-solid tw-border-jr-line tw-pt-5 tw-text-[14px]",
                                                children: [
                                                    estimate.rangeMinUsd && estimate.rangeMaxUsd && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                className: "tw-text-jr-mute",
                                                                children: "Khoảng gi\xe1 nguồn c\xf4ng bố"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                                className: "tw-m-0 tw-mt-1 tw-tabular-nums",
                                                                children: [
                                                                    (0,diamond_catalogue_view/* diamondUsd */.iO)(estimate.rangeMinUsd),
                                                                    " – ",
                                                                    (0,diamond_catalogue_view/* diamondUsd */.iO)(estimate.rangeMaxUsd),
                                                                    " USD"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                className: "tw-text-jr-mute",
                                                                children: "Gi\xe1 ước t\xednh tr\xean carat"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                                className: "tw-m-0 tw-mt-1 tw-tabular-nums",
                                                                children: [
                                                                    (0,diamond_catalogue_view/* diamondUsd */.iO)(estimate.pricePerCaratUsd || estimate.priceUsd / input.carat),
                                                                    " USD/ct"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    estimate.change30dPercent !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                className: "tw-text-jr-mute",
                                                                children: "Biến động 30 ng\xe0y theo nguồn"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dd", {
                                                                className: "tw-m-0 tw-mt-1 tw-tabular-nums",
                                                                children: [
                                                                    estimate.change30dPercent > 0 ? "+" : "",
                                                                    estimate.change30dPercent,
                                                                    "%"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-mt-4 tw-mb-0 tw-text-[17px] tw-leading-relaxed",
                                        children: "Gi\xe1 cho cấu h\xecnh n\xe0y đang được bổ sung. Bạn c\xf3 thể xem đầy đủ th\xf4ng số b\xean dưới hoặc mở StoneAlgo để đối chiếu trực tiếp."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: sourceUrl,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "tw-mt-5 tw-inline-flex tw-min-h-[44px] tw-items-center tw-text-[14px] tw-text-jr-green tw-underline tw-underline-offset-4",
                                        children: "Đối chiếu cấu h\xecnh tr\xean StoneAlgo ↗"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "tw-mt-4 tw-mb-0 tw-text-[13px] tw-leading-relaxed tw-text-jr-mute",
                        children: [
                            "Đ\xe2y l\xe0 mức ước t\xednh cho một cấu h\xecnh, chưa phải b\xe1o gi\xe1 b\xe1n hoặc hồ sơ của một vi\xean đ\xe1 cụ thể tại An Thư. H\xecnh tr\xean l\xe0 minh họa d\xe1ng cắt.",
                            (usd === null || usd === void 0 ? void 0 : usd.sell) ? " Quy đổi theo tỷ gi\xe1 b\xe1n Vietcombank ".concat((0,diamond_catalogue_view/* diamondVnd */.Aq)(usd.sell), " VND/USD, dữ liệu ng\xe0y ").concat((0,diamond_catalogue_view/* diamondDate */.OR)(usd.updatedAt), ".") : " Chưa c\xf3 tỷ gi\xe1 quy đổi VND từ nguồn."
                        ]
                    }),
                    (usd === null || usd === void 0 ? void 0 : usd.sell) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: usd.sourceUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "tw-mt-2 tw-inline-block tw-text-[13px] tw-text-jr-green tw-underline",
                        children: "Xem nguồn tỷ gi\xe1 Vietcombank ↗"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
                className: "!tw-pt-2 !tw-pb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-grid tw-gap-8 lg:tw-grid-cols-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "tw-m-0 tw-font-jr tw-text-[28px] tw-font-normal",
                                    children: "Th\xf4ng số d\xf9ng để ước t\xednh"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                                    className: "tw-mt-5 tw-mb-0 tw-overflow-hidden tw-rounded-lg tw-border tw-border-jr-line tw-bg-white",
                                    children: specs.map(function(param) {
                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), label = _param[0], value = _param[1];
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-grid tw-grid-cols-2 tw-gap-3 tw-border-0 tw-border-b tw-border-solid tw-border-jr-line tw-px-4 tw-py-3 last:tw-border-b-0 tw-text-[14px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                    className: "tw-text-jr-mute",
                                                    children: label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                    className: "tw-m-0 tw-text-right tw-font-medium",
                                                    children: value
                                                })
                                            ]
                                        }, label);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-mt-3 tw-text-[13px] tw-leading-relaxed tw-text-jr-mute",
                                    children: "C\xe1c th\xf4ng số tr\xean l\xe0 đầu v\xe0o của c\xf4ng cụ gi\xe1, kh\xf4ng x\xe1c nhận chất lượng hay số b\xe1o c\xe1o GIA của một vi\xean đ\xe1 đang b\xe1n."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-min-w-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "tw-m-0 tw-font-jr tw-text-[28px] tw-font-normal",
                                    children: "Đọc mức gi\xe1 n\xe0y như thế n\xe0o?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "tw-mt-5 tw-text-[15px] tw-leading-relaxed tw-text-jr-mute",
                                    children: [
                                        "Mục n\xe0y d\xf9ng cấu h\xecnh ",
                                        shape.name,
                                        " ",
                                        (0,diamond_catalogue_view/* diamondCarat */.w1)(input.carat),
                                        " carat, m\xe0u ",
                                        input.color,
                                        ", độ sạch ",
                                        input.clarity,
                                        " để lấy ước t\xednh quốc tế từ StoneAlgo. Khi nguồn c\xf3 dữ liệu, trang hiển thị mức ước t\xednh v\xe0 ng\xe0y dữ liệu của ch\xednh nguồn."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-text-[15px] tw-leading-relaxed tw-text-jr-mute",
                                    children: "Gi\xe1 bằng VND chỉ l\xe0 ph\xe9p quy đổi từ USD theo tỷ gi\xe1 b\xe1n Vietcombank được ghi ở tr\xean. Khi cần mua một vi\xean thực tế, h\xe3y đối chiếu b\xe1o c\xe1o kiểm định, h\xecnh ảnh v\xe0 b\xe1o gi\xe1 của vi\xean đ\xf3 với tư vấn vi\xean An Thư."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-mt-5 tw-flex tw-flex-wrap tw-gap-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                            href: "/accounts/appointment/new/",
                                            children: "Nhận tư vấn tại An Thư"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                            href: "/bang-gia/kim-cuong/",
                                            tone: "light",
                                            children: "Chọn th\xf4ng số kh\xe1c"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components.A, {
                                    href: "/tin-tuc/kien-thuc-kim-cuong/",
                                    className: "tw-mt-5 tw-inline-block tw-text-[14px] tw-text-jr-green tw-underline",
                                    children: "T\xecm hiểu kiến thức kim cương →"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
                className: "!tw-pt-4 !tw-pb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "tw-m-0 tw-mb-5 tw-font-jr tw-text-[28px] tw-font-normal",
                        children: [
                            "So s\xe1nh cấu h\xecnh c\xf9ng ",
                            (0,diamond_catalogue_view/* diamondCarat */.w1)(input.carat),
                            " carat"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-grid tw-gap-4 md:tw-grid-cols-3",
                        children: related.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(diamond_catalogue_view/* DiamondProfileLink */.fM, {
                                profile: item
                            }, item.slug);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components.A, {
                        href: catalogueHref,
                        className: "tw-mt-6 tw-inline-flex tw-min-h-[44px] tw-items-center tw-text-[14px] tw-font-medium tw-text-jr-green",
                        children: "← Về danh s\xe1ch gi\xe1 tham khảo"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/bang-gia/kim-cuong/[slug]/index.tsx

var __N_SSP = true;
/* harmony default export */ var _slug_ = (DiamondDetailLayout);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2031,8276,4904,6874,9774,2888,179], function() { return __webpack_exec__(99392); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);